import logo from "../../images/logo.png";
import { ReactComponent as DashboardIcon } from "../../images/dashboard.svg";
import { ReactComponent as ReportIcon } from "../../images/treatment.svg";
import { ReactComponent as UsersIcon } from "../../images/users.svg";
import { ReactComponent as SubscriptionIcon } from "../../images/folder-tree.svg";
import { ReactComponent as QuerySupportIcon } from "../../images/interrogation.svg";
import { ReactComponent as ArrowIcon } from "../../images/arrow-small-left.svg";
import { ReactComponent as ListIcon } from "../../images/list.svg";
import { ReactComponent as BillingIcon } from "../../images/file-invoice-dollar.svg";
import { ReactComponent as ClientIcon } from "../../images/client-profile.svg";
import { ReactComponent as FileIcon } from "../../images/document.svg";
import { ReactComponent as ActivityIcon } from "../../images/badge-sheriff.svg";
import { ReactComponent as BellIcon } from "../../images/bell.svg";
import "../../styles/sidebar.css";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import IconInput from "./IconInput";
import {
  CLIENT_ADVERTISER,
  CLIENT_AGENCY,
  CLIENT_BROADCASTER,
  LS_LAST_DATA_DATE,
  USER_BUSINESS_ADMIN,
  USER_SUPERADMIN,
} from "core/Constants";
import dataProvider from "core/DataProvider";

let sidebarItems = [
  {
    title: "Dashboard",
    icon: <DashboardIcon />,
    path: "/dashboard",
    users: [USER_BUSINESS_ADMIN, USER_SUPERADMIN],
    clients: [CLIENT_AGENCY, CLIENT_ADVERTISER, CLIENT_BROADCASTER],
  },
  {
    title: "Reports",
    icon: <ReportIcon />,
    path: "/reports",
    users: [USER_BUSINESS_ADMIN, USER_SUPERADMIN],
    clients: [CLIENT_AGENCY, CLIENT_ADVERTISER, CLIENT_BROADCASTER],
  },
  {
    title: "Masters",
    icon: <ListIcon />,
    path: "/masters",
    users: [USER_BUSINESS_ADMIN, USER_SUPERADMIN],
    clients: [],
  },
  {
    title: "Account Managers",
    icon: <UsersIcon />,
    path: "/account-managers",
    users: [USER_BUSINESS_ADMIN, USER_SUPERADMIN],
    clients: [],
  },
  {
    title: "User Management",
    icon: <UsersIcon />,
    path: "/users",
    users: [USER_BUSINESS_ADMIN, USER_SUPERADMIN],
    clients: [CLIENT_AGENCY, CLIENT_ADVERTISER, CLIENT_BROADCASTER],
  },
  {
    title: "Subscription",
    icon: <SubscriptionIcon />,
    path: "/subscriptions",
    users: [USER_BUSINESS_ADMIN, USER_SUPERADMIN],
    clients: [CLIENT_AGENCY, CLIENT_ADVERTISER, CLIENT_BROADCASTER],
  },
  {
    title: "Billing",
    icon: <BillingIcon />,
    path: "/billing",
    users: [USER_BUSINESS_ADMIN, USER_SUPERADMIN],
    clients: [],
  },
  {
    title: "Clients",
    icon: <ClientIcon />,
    path: "/clients",
    users: [USER_BUSINESS_ADMIN, USER_SUPERADMIN],
    clients: [],
  },
  // {
  //   title: "Query Support",
  //   icon: <QuerySupportIcon />,
  //   path: "/support",
  //   users: [USER_BUSINESS_ADMIN, USER_SUPERADMIN],
  //   clients: [CLIENT_AGENCY, CLIENT_ADVERTISER, CLIENT_BROADCASTER],
  // },
  {
    title: "File Details",
    icon: <FileIcon />,
    path: "/file",
    users: [USER_BUSINESS_ADMIN, USER_SUPERADMIN],
    clients: [],
  },
  {
    title: "Notification",
    icon: <BellIcon />,
    path: "/notification",
    users: [USER_SUPERADMIN, USER_BUSINESS_ADMIN],
    clients: [],
  },
  {
    title: "Activity Tracker",
    icon: <ActivityIcon />,
    path: "/activity",
    users: [USER_BUSINESS_ADMIN, USER_SUPERADMIN],
    clients: [],
  },
  // {
  //   title: "Query Executor",
  //   icon: <QueryExIcon />,
  //   path: "/queryex",
  //   users: [USER_BUSINESS_ADMIN, USER_SUPERADMIN],
  //   clients: [],
  // },
];

const Sidebar = props => {
  const [collapsed, setCollapsed] = useState(false);
  const [dataDate, setDataDate] = useState(null);

  const permCheck = item => {
    let show = false;

    if (role_permission_check(item)) {
      show = true;
    }

    return show;
  };

  const role_permission_check = item => {
    let show = false;

    for (let i = 0; i < props.menuPermissions.length; i++) {
      if (props.menuPermissions[i].pathname.includes(item.path)) {
        show = true;
        break;
      }
    }

    return show;
  };

  useEffect(() => {
    // const getLastDataDate = async () => {
    //   try {
    //     let res = await dataProvider.network.get("masters/last-upload");
    //     setDataDate(new Date(res.timestamp));
    //   } catch (error) {
    //     console.error(error);
    //   }
    // };
    // getLastDataDate();
  }, []);

  return (
    <div id="sidebar" className={collapsed ? "collapsed" : ""}>
      <div id="logo">
        <img src={logo} alt="SpotTrek" />
      </div>
      <div className="search">
        <IconInput icon="search" placeholder="Search" />
      </div>
      <ul id="menu">
        {sidebarItems.map(
          item =>
            permCheck(item) && (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <span className="icon">{item.icon}</span>
                <span className="text">{item.title}</span>
              </NavLink>
            )
        )}
      </ul>
      {/* <p className="text-center last-date">
        Latest Data: <span>{dataDate ? dataDate.toDateString() : ""}</span>
      </p> */}
      <div className="collapser" onClick={_ => setCollapsed(!collapsed)}>
        <ArrowIcon />
      </div>
    </div>
  );
};

export default Sidebar;
